<template>
  <div class="ClientLogin">
    <img src="../../assets/img/bg.jpg" alt="" class="bg" />

    <div class="content">
      <h3>登录入口</h3>
      <div class="formBox" v-show="curIndex === 0">
        <input ref="username" type="text" placeholder="账号" />
        <input ref="password" type="password" placeholder="密码" />
        <button @click="login">登录</button>
      </div>
      <div class="formBox" v-show="curIndex === 1">
        <input ref="signEmail" type="text" placeholder="请输入注册的邮箱" />
        <input ref="signName" type="text" placeholder="请输入昵称" />
        <input ref="signPwd" type="password" placeholder="请输入密码" />
        <input ref="signRecipient" type="text" placeholder="请输入收件人姓名" />
        <input ref="signAddress" type="text" placeholder="请输入收件地址" />
        <input ref="signPhone" type="text" placeholder="请输入联系电话" />
        <button @click="signup">注册</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { login } from "@/api/platform";
export default {
  name: "ClientLogin",
  computed: {
  },
  data () {
    return {
      curIndex: 0,
    };
  },
  methods: {
    ...mapMutations({
      setClientName: "SET_CLIENT_NAME",
      setClientToken: "SET_CLIENT_TOKEN",
    }),
    setIndex (index) {
      if (index === this.curIndex) {
        return;
      }
      this.curIndex = index;
    },
    async login () {
      const username = this.$refs.username.value;
      const password = this.$refs.password.value;
      const { result } = await login({
        username,
        password,
      });

      this.setClientToken(result.token);
      this.setClientName(result.name);
      localStorage.setItem("user", JSON.stringify(result));
      this.$router.push("/");
    },
    signup () {
    },
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';
.ClientLogin {
  background-color: @bgColor;
  position: relative;
  width: 100vw;
  height: 100vh;
  .bg {
    width: 100vw;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    object-fit: cover;
  }
  .content {
    // width: 300px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(50%, -50%);
    text-align: center;
    overflow: hidden;
    h3 {
      width: 90%;
      // color: @secondColor;
      color: rgb(204, 1, 0);
      font-size: 50px;
      display: flex;
      align-items: center;
      margin-left: 5%;
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: 1px solid rgb(89, 89, 89);
    }
    .tag {
      height: 40px;
      margin-top: 20px;
      color: @fontDefaultColor;
      margin-bottom: 20px;
      span {
        display: inline-block;
        width: 50px;
        text-align: center;
        margin: 0 10px;
        padding: 10px 0;
        cursor: pointer;
      }
      .selected {
        border-bottom: 2px solid @secondColor;
        color: @secondColor;
      }
    }
    input {
      border-radius: 0;
      box-shadow: none;
      background: #fff;
      padding: 14px;
      width: 90%;
      border: 1px solid @borderColor;
      margin-bottom: 10px;
    }
    button {
      width: 90%;
      // background: @secondColor;
      background: rgb(204, 1, 0);
      box-shadow: none;
      border: 0;
      border-radius: 3px;
      line-height: 41px;
      color: #fff;
      cursor: pointer;
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/client/MallLogin.vue